import PicklistMetadata from "../PicklistMetadata";

// The relationship types that mean something BETWEEN TWO RULES — Supersedes, Stricter than,
// Depends on, Part of, Variant of, Conflicts with.
//
// A separate picklist rather than a filter on the shared one, because the two vocabularies have
// nothing to say to each other: "Backup of" is meaningless between two quality rules, and
// "Supersedes" is meaningless between two business terms. Before this the rule Relationships tab
// offered the data-asset list, which is why nobody had ever made a rule relationship.
class RuleRelationshipTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RuleRelationshipType";
        this.static = false;
        this.enterpriseComponent = "RelationshipType";
        this.useRealm = false;
        // An EQUAL QBE member against the IDOC tag "ObjectType", the same mechanism the Position
        // picker uses to restrict itself to one Focus Area.
        this.searchSpecification = {"ObjectType": "Rule"};
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default RuleRelationshipTypePicklistMetadata;
